import React from 'react';
import Hero from '../components/Hero';
import Services from './Services';
import About from './About';
import Testimonials from '../components/Testimonials';
import BlogSection from '../components/BlogSection';

const Home = () => {
  return (
    <main>
      <Hero />
      <Services compactTop />
      <About showTeam={false} />
      <Testimonials />
      <BlogSection />
    </main>
  );
};

export default Home;
